export default "__VITE_ASSET__D_JkQ6qT__"